import React from "react";

import NewFormRow from "../../../../../../shared/forms/NewFormRow";
import NewSelect from "../../../../../../shared/forms/NewSelect";
import useCalulatorStore from "../../../../CalculatorPage/store";

const TimePicker = ({ value, onChange, withAdditions = false }) => {
    const [additions] = useCalulatorStore((state) => [state.additions]);

    /**
     * When the value changes.
     * @param {*} event
     */
    const onChangeValue = (event) => {
        onChange(event.target.value);
    };

    return (
        <NewFormRow>
            <NewFormRow.Label>Uhrzeit</NewFormRow.Label>
            <NewFormRow.Value>
                <NewSelect
                    value={value !== null ? value : ""}
                    onChange={onChangeValue}
                    options={Object.keys(additions.time_frames).map((key) => {
                        return {
                            value: key,
                            text:
                                String(additions.time_frames[key].name) +
                                String(
                                    withAdditions
                                        ? additions.time_frames[key].add !==
                                              "0,00" &&
                                              ` (+${additions.time_frames[key].add} €)`
                                        : ""
                                ),
                        };
                    })}
                />
            </NewFormRow.Value>
        </NewFormRow>
    );
};

export default TimePicker;
